import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getData, getDataById, getcountries, getpaymentType, getseries, getsubdomains } from '../../../services/admin/paymentReceipt/paymentReceiptGeneratedServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';


const PaymentReceiptGenerated = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id: '',
    accommodation : '',
    accommodation_status : '',
    billing_address : '',
    billing_countries : '',
    billing_email : '',
    billing_full_name : '',
    billing_phone_no : '',
    createdAt : '',
    currency_type : '',
    date_of_payment : '',
    event_date : '',
    event_title : '',
    event_type : '',
    no_of_ticket : '',
    occupancy_type : '',
    payment_id : '',
    payment_type : '',
    pdf_status : '',
    receipt_date : '',
    refund_status : '',
    reg_amount : '',
    reg_amount_usd : '',
    reg_category : '',
    reg_type : '',
    series : '',
    shipping : '',
    shipping_address : '',
    shipping_countries : '',
    shipping_email : '',
    shipping_full_name : '',
    shipping_phone_no : '',
    sub_domain : '',
    subject : '',
    total_no_of_nights : '',
    transaction_id : '',
    updatedAt : ''
  });
  
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const debounceTimeoutRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [seriesFilter, setSeriesFilter] = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    countries: [],
    paymentType: [],
    subdomains: [],
    series: []
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  
  // Debounce Effect
  useEffect(() => {
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);

    debounceTimeoutRef.current = setTimeout(() => {
      setDebouncedSearch(searchText);
      setCurrentPage(1); // reset page only when actual search triggered
    }, 600); // 500ms debounce delay

    return () => clearTimeout(debounceTimeoutRef.current);
  }, [searchText]);

  // Fetch data list
   const fetchData = useCallback(async () => {
        setLoading(true);
        try {
          const filters = {};
          if (seriesFilter) filters.series = seriesFilter;
          if (subDomainFilter) filters.sub_domain = subDomainFilter;
          if (countryFilter) filters.country = countryFilter;
    
          const params = {
            pdf_status: 1,
            page: currentPage,
            limit: rowsPerPage,
            search: debouncedSearch,
            filters,
            startDate: startDate || null,
            endDate: endDate || null,
          };
    
         const response = await getData(params);
         // ✅ Console log the full API response
          console.log('Fetched Data:', response);
          setDataList(response.rows);
          setTotalRows(response.count);
        } catch (error) {
          console.error('Failed to fetch data:', error);
        } finally {
          setLoading(false);
        }
    }, [currentPage, rowsPerPage, debouncedSearch, subDomainFilter, seriesFilter, countryFilter, startDate, endDate]);
    
 
   // Fetch all dropdown data
    const fetchDropdownData = useCallback(async () => {
      try {
        const [country, payment, subdomains, series] = await Promise.all([
          getcountries(),
          getpaymentType(),
          getsubdomains(),            
          getseries()                        
        ]);
        
         // ✅ Make series unique based on string value
        const uniqueSeries = [...new Set(series.map(item => item.series))].map(series => ({
          series: series
        }));
   
        setDropdownData({
          countries: country,
          paymentType: payment,
          subdomains: subdomains,
          series: uniqueSeries
        });
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    }, []);

    useEffect(() => {
      fetchDropdownData();
    }, [fetchDropdownData]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);

  // Inside your PaymentReceiptGenerated component
  const navigate = useNavigate();  // Initialize the useHistory hook

  const pdfModal = async (type, row) => {
    try {
      // Send the ID in the body of a POST request
      const data = await getDataById({ id: row.id });

      // If the data is fetched successfully, navigate to the PDF page
      if (data) {
        // Assuming you want to pass the data to another page
        navigate('/paymentReceiptPdf', { state: { data } });  // Use navigate to go to PDF page with state
      }
    } catch (error) {
      console.error('Error fetching data by ID:', error);
    }
  };

  const openViewModal = ( data = { 
    id: '',
    accommodation : '',
    accommodation_status : '',
    billing_address : '',
    billing_countries : '',
    billing_email : '',
    billing_full_name : '',
    billing_phone_no : '',
    createdAt : '',
    currency_type : '',
    date_of_payment : '',
    event_date : '',
    event_title : '',
    event_type : '',
    no_of_ticket : '',
    occupancy_type : '',
    payment_id : '',
    payment_type : '',
    pdf_status : '',
    receipt_date : '',
    refund_status : '',
    reg_amount : '',
    reg_amount_usd : '',
    reg_category : '',
    reg_type : '',
    series : '',
    shipping : '',
    shipping_address : '',
    shipping_countries : '',
    shipping_email : '',
    shipping_full_name : '',
    shipping_phone_no : '',
    sub_domain : '',
    subject : '',
    total_no_of_nights : '',
    transaction_id : '',
    updatedAt : ''
  }) => {
    setForm(data);
    setShowViewModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };
    
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  };

 //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  //based country code append country name
  const getPaymentTypeName = (code) => {
  const payment = dropdownData.paymentType.find(c => c.code === code);
  return payment ? payment.type : code;
  };


 //Filtered data
  // const filteredData = useMemo(() => {
  // const startDateObj = startDate ? new Date(startDate) : null;
  // const endDateObj = endDate ? new Date(endDate) : null;
  
  //     return dataList
  //       .filter((data) => {
  //         const matchesText =
  //           data.billing_full_name.toLowerCase().includes(searchText.toLowerCase()) ||
  //           data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
  //           data.reg_amount.toString().includes(searchText.toLowerCase()) ||
  //           data.currency_type.toLowerCase().includes(searchText.toLowerCase()) ||
  //           data.event_type.toLowerCase().includes(searchText.toLowerCase()) ||
  //           data.date_of_payment.toString().includes(searchText.toLowerCase());
  
  //          const date = data.date_of_payment ? new Date(data.date_of_payment) : null;
  
  //         // If both startDate and endDate are provided, filter by date range
  //         const inRange = (startDateObj && endDateObj) 
  //           ? date >= startDateObj && date <= endDateObj 
  //           : true; // Otherwise, no date filtering
  
  //         // Other filters (series, subDomain, country)
  //         const matchSeries = !seriesFilter || data.series === seriesFilter;
  //         const matchSubDomain = !subDomainFilter || data.sub_domain === subDomainFilter;
  //         const matchCountry = !countryFilter || data.billing_countries === countryFilter;
  
  //         return matchesText && inRange && matchSeries && matchSubDomain && matchCountry;
  //       }).sort((a, b) => new Date(b.date_of_payment) - new Date(a.date_of_payment));
  // }, [dataList, searchText, seriesFilter, subDomainFilter, countryFilter, startDate, endDate]);
    

  const columns = [
    { 
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Date of Payment',
      selector: (row) => row.date_of_payment,
      sortable: true,
      wrap:true,
      width: '10%',
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    wrap:true,
    width: '10%',
   },
    {
      name: 'Sub domain',
      selector: (row) => row.sub_domain,
      sortable: true,
      wrap:true,
      width: '10%',
    },
    {
      name: 'Name',
      selector: (row) => row.billing_full_name,
      sortable: true,
      wrap:true,
      width: '15%',
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_countries),
      sortable: true,
      wrap:true,
      width: '15%',
    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency_type);
        return <b className='fs-4'>{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
      width: '10%',
      wrap:true
    },
    {
      name: 'Event Type',
      selector: (row) => row.event_type,
      sortable: true,
      width: '10%',
      wrap:true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="primary" size="sm" onClick={() => openViewModal(row)} className="me-2"> <i className="align-middle far fa-fw fa-eye"></i> </Button>
          <Button variant="danger" size="sm" onClick={() => pdfModal('edit', row)} > <i className="align-middle far fa-fw fa-file-pdf"></i>PDF</Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
             <div className="col-md-2">
              <span className='fs-5 text-dark'>Series</span>
              <select className="form-control" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                <option value="">All Series</option>
                {dropdownData.series.sort((a, b) => b.series.localeCompare(a.series)).map((series) => (
                  <option key={series.series} value={series.series}>{series.series}</option>
                ))}
              </select>
            </div>
            {/* Dropdown for Filters */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Sub Domain</span>
              <select className="form-control" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                <option value="">All Subdomains</option>
                {dropdownData.subdomains.sort((a, b) => a.sub_domain.localeCompare(b.sub_domain)).map((subdomains) => (
                  <option key={subdomains.sub_domain} value={subdomains.sub_domain}>{subdomains.sub_domain}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='fs-4 text-dark'>PDF Generation / Payment Receipt / Generated Receipt </p>
            </div>
          </div>

          <DataTable
                columns={columns}
                data={dataList}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={rowsPerPage}
                paginationRowsPerPageOptions={[10, 30, 50, 100, 500]}
                onChangePage={handlePageChange}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                responsive
                striped
                subHeader
                subHeaderComponent={
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                  />
                }
            />

          {/* View Modal */}
          <Modal className="modal-lg" backdrop="static" show={showViewModal} onHide={() => setShowViewModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
            <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Payment Receipt Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Event Type</td>
                    <td>{form.event_type}</td>
                  </tr>
                  <tr>
                    <td>Receipt Date</td>
                    <td>{form.receipt_date}</td>
                  </tr>
                  <tr>
                    <td>Payment ID</td>
                    <td>{form.payment_id}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Billing Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Full Name</td>
                    <td>{form.billing_full_name}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{form.billing_email}</td>
                  </tr>
                  <tr>
                    <td>Phone No</td>
                    <td>{form.billing_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{form.billing_address}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{getCountryName(form.billing_countries)}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Shipping Address</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Full Name</td>
                    <td>{form.shipping_full_name}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{form.shipping_email}</td>
                  </tr>
                  <tr>
                    <td>Phone No</td>
                    <td>{form.shipping_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{form.shipping_address}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{getCountryName(form.shipping_countries)}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Payment Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Date of Payment</td>
                    <td>{form.date_of_payment}</td>
                  </tr>
                  <tr>
                    <td>Mode of Payment</td>
                    <td>{getPaymentTypeName(form.payment_type)}</td>
                  </tr>
                  <tr>
                    <td>Currency</td>
                    <td>{form.currency_type}</td>
                  </tr>
                  <tr>
                    <td>Registration Amount</td>
                    <td>{form.reg_amount}</td>
                  </tr>
                  <tr>
                    <td>Registration Type</td>
                    <td>{form.reg_type}</td>
                  </tr>
                  <tr>
                    <td>Registration Category</td>
                    <td>{form.reg_category}</td>
                  </tr>
                  <tr>
                    <td>No. of Ticket</td>
                    <td>{form.no_of_ticket}</td>
                  </tr>
                  {form.occupancy_type && (
                  <tr>
                    <td>Occupancy</td>
                    <td>{form.occupancy_type}</td>
                  </tr>
                    )}
                  {form.total_no_of_nights && (
                  <tr>
                    <td>No. of Nights</td>
                    <td>{form.total_no_of_nights}</td>
                  </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default PaymentReceiptGenerated;